import { useInfiniteQuery } from 'react-query';
import itemsForLabelServices from './items-label.services';
import { ItemLabelRequest } from './items-label.types';

export const ITEMS_FOR_LABEL_LIST_KEY = 'items/label/list';

export function useItemsForLabelList(
  params?: ItemLabelRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [ITEMS_FOR_LABEL_LIST_KEY, { ...params }],
    queryFn: ({ pageParam }) =>
      itemsForLabelServices.list({ ...params, page: pageParam || 1 }),
    getNextPageParam: (lastPage) => {
      const totalPages = lastPage.result?.totalPages || 1;
      const currPage = lastPage.result?.page || 1;

      if (currPage < totalPages) return currPage + 1;
    },
    enabled: !!params?.companyId && enabled,
  });
}
